import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useGetFindAllAttendanceDeclarationMutation } from '../../../services/schedule.service';
import { ISchedules } from '../../../services/journey.service';
import AttendanceDeclarationModel from './model';

export default function AttendanceDeclarationViewModel() {
  const navigate = useNavigate();
  const [fetchDeclarations, { data, isLoading }] = useGetFindAllAttendanceDeclarationMutation();

  useEffect(() => {
    fetchDeclarations({ page: 1, orderBy: 'date', direction: 'DESC', quantity: 5 });
  }, []);

  const schedules: ISchedules[] = AttendanceDeclarationModel.getRecent(data?.items ?? [], 5);

  const goToSolicitar = () => navigate('/arquivos/declaracao-de-comparecimento/solicitar');

  return { isLoading, schedules, goToSolicitar };
}
